import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Item, Section} from '../catalog-manager.models';
import {AdminService} from "../../../../services/AdminService";
import {NavController} from "@ionic/angular";

@Component({
    selector: 'app-item-details',
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss']
})
export class ItemDetailsComponent implements OnInit {
    @Input() item: Item | null = null;
    @Input() sections: Section[] = [];
    @Input() isMarked: boolean = false;

    @Output() sectionRemoved = new EventEmitter<number>();
    @Output() closed = new EventEmitter<void>();
    @Output() markToggled = new EventEmitter<void>();
    @Output() itemDragStart = new EventEmitter<DragEvent>();

    images = []

    constructor(private adminSerivce: AdminService, public nav: NavController) {
    }

    ngOnInit() {
    }

    removeImage(image) {
        this.adminSerivce.removeModels('modelToImage', [image['id']], function () {
            image['removed'] = true;
        });
    }

    getItemSections(): Section[] {
        if (!this.item) return [];
        return this.sections.filter(s => this.item!.section_ids.includes(s.id));
    }

    removeSectionFromItem(sectionId: number) {
        // if (confirm('Remove this section from the item?')) {
        this.sectionRemoved.emit(sectionId);
        // }
    }

    close() {
        this.closed.emit();
    }

    onMarkToggle() {
        this.markToggled.emit();
    }

    onDragStart(event: DragEvent) {
        if (!this.item) return;

        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'copyMove';
            event.dataTransfer.setData('application/json', JSON.stringify([this.item.id]));
            event.dataTransfer.setData('text/plain', JSON.stringify([this.item.id]));
        }

        this.itemDragStart.emit(event);
    }
}
